module.exports = __webpack_public_path__ + "static/media/eid.00f188e5.png";